module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-3.e7ee1fb6.png";